import { createSelector } from '@reduxjs/toolkit';

import { RootState } from 'types';
import { initialState } from '.';

const selectSlice = (state: RootState) => state.dropdownBar || initialState;

export const selectDropdownBar = createSelector(
  [selectSlice],
  state => state,
);
